/* eslint-disable ember/no-mixins */
import { inject as service } from '@ember/service';
import DS from 'ember-data';
import Route from 'cio/routes/base';
import ContentIndexController from 'cio/pods/broadcasts/newsletter/setup/content/index/controller';

import NewsletterModel from 'cio/models/newsletter';
import Transition from '@ember/routing/-private/transition';
import ConfirmChangesService from 'cio/services/confirm-changes';

export default class ContentIndexRoute extends Route {
  @service store!: DS.Store;
  @service confirmChanges!: ConfirmChangesService;

  model() {
    return this.store.findRecord(
      'newsletter',
      (this.paramsFor('broadcasts.newsletter') as { newsletter_id: string }).newsletter_id,
    );
  }

  setupController(controller: ContentIndexController, model: NewsletterModel, transition: Transition) {
    super.setupController(controller, model, transition);
    controller.setDefaults();
    controller.set('hasTestSetup', model.hasTestSetup);
    this.confirmChanges.register(controller, this);
  }
}
